import Cookies from "js-cookie";
import authHeader from "../../helpers/authHeader";
import { handleResponse } from "../../helpers/handleResponse";
import { history } from "../../helpers/history";

const API_URL = process.env.REACT_APP_API_URL

const login = (email, password) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({ email, password }),
    credentials: "include",
  };
  return fetch(
    API_URL + "/auth/login/",
    requestOptions
  ).then((res) => {
    return handleResponse(res, false).then((user) => {
      window.localStorage.setItem("user", JSON.stringify(user));
      return Promise.resolve(user);
    });
  });
};

const loginClever = (user) => {
  window.localStorage.setItem("user", JSON.stringify(user));
  window.history.replaceState(null, null, window.location.href.split('?')[0]);
  history.push(
    user.userObj.role === "Student"
      ? "/landing-page"
      : user.userObj.role === "LeadTeacher" || user.userObj.role === "AssistTeacher"
      ? "/teacher-schedule"
      : "/"
  );
  return user;
};

const logout = () => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    credentials: "include",
  };
  // remove user from local storage to log user out

  return fetch(
    API_URL + "/auth/logout/",
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      localStorage.removeItem("user");
      Cookies.remove("csrftoken");
      history.push("/login");
      localStorage.removeItem("selectedSet");
    });
};

const logoutNoRedirect = () => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    credentials: "include",
  };
  // remove user from local storage to log user out

  return fetch(
    API_URL + "/auth/logout/",
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      localStorage.removeItem("user");
      Cookies.remove("csrftoken");
    });
};

const register = (user) => {
  // eslint-disable-next-line eqeqeq
  if (user["role"] != "10") {
    user["role"] = "Editor";
  } else {
    user["role"] = "Admin";
  }
  const pass = Math.random().toString(36).substring(7);
  const data = {
    email: user["email"],
    first_name: user["first_name"],
    last_name: user["last_name"],
    role: user["role"],
    password: pass,
    user_type: user["user_type"],
  };

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
    credentials: "include",
  };

  return fetch(API_URL + "/user/", requestOptions).then(handleResponse);
};
const confirmUser = (user) => {
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
    credentials: "include",
  };

  return fetch(API_URL + "/user/confirm-token/", requestOptions).then((res) => {
    return handleResponse(res, false).then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user));
      history.push("/admin/dashboard");
      return Promise.resolve(user);
    });
  });
};

const resetPassword = (email) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({ email }),
    credentials: "include",
  };

  return fetch(API_URL + "/user/reset-password/", requestOptions).then(
    handleResponse
  );
};
const resetUserPassword = (data) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
    credentials: "include",
  };

  return fetch(API_URL + "/user/confirm-token/", requestOptions).then(
    handleResponse
  );
};

export const contactUs = (data) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
    credentials: "include",
  };

  return fetch(API_URL + "/user/contact-us/", requestOptions).then(handleResponse);
};

const getAllUserTypes = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
    credentials: "include",
  };
  return fetch(API_URL + "/user-type/", requestOptions).then(handleResponse);
};

const createUserType = (userTypeObject) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(userTypeObject),
    credentials: "include",
  };

  return fetch(API_URL + "/user-type/", requestOptions).then(handleResponse);
};

const updateUserType = (userTypeObject) => {
  const requestOptions = {
    method: "PATCH",
    headers: authHeader(),
    body: JSON.stringify(userTypeObject),
    credentials: "include",
  };

  return fetch(API_URL + `/user-type/${userTypeObject.id}/`, requestOptions).then(
    handleResponse
  );
};

const deleteUserType = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    credentials: "include",
  };

  return fetch(API_URL + `/user-type/${id}/`, requestOptions).then(handleResponse);
};

const getAllUsers = (pageNumber) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
    credentials: "include",
  };
  return fetch(
    API_URL + `/user/?limit=10&offset=${pageNumber}`,
    requestOptions
  ).then(handleResponse);
};

const updateUser = (user) => {
  if (user["role"] !== "SystemAdministrator") {
    user["role"] = "Editor";
  } else {
    user["role"] = "Admin";
  }
  const requestOptions = {
    method: "PATCH",
    headers: authHeader(),
    body: JSON.stringify(user),
    credentials: "include",
  };

  return fetch(API_URL + `/user/${user.id}/`, requestOptions).then(handleResponse);
};

// prefixed function name with underscore because delete is a reserved word in javascript
const deleteUser = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    credentials: "include",
  };

  return fetch(API_URL + `/user/${id}/`, requestOptions).then(handleResponse);
};

const getOneUser = (id) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
    credentials: "include",
  };
  return fetch(API_URL + `/user/${id}/`, requestOptions).then(handleResponse);
};

const settings = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
    credentials: "include",
  };
  return fetch(API_URL + `/settings/path/public/terms-condition/`, requestOptions).then(handleResponse);
};

const sendInvitation = (id) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({ id }),
    credentials: "include",
  };

  return fetch(API_URL + `/user/send-invitation/`, requestOptions).then(
    handleResponse
  );
};

export default {
  login,
  logout,
  logoutNoRedirect,
  loginClever,
  register,
  getAllUsers,
  updateUser,
  deleteUser,
  getOneUser,
  confirmUser,
  sendInvitation,
  resetPassword,
  resetUserPassword,
  contactUs,
  createUserType,
  getAllUserTypes,
  updateUserType,
  deleteUserType,
  settings,
};
